import { c as _c } from "react/compiler-runtime";
import { patchOrgAgentsMcpServersByServerIdMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import type { AgentMcpServer } from '@onefootprint/request-types/dashboard';
import { Dialog, Form, useToast } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
type ReplaceHeaderValueDialogProps = {
  server: AgentMcpServer;
  onClose: () => void;
};
type FormData = {
  headerValue: string;
};
const ReplaceHeaderValueDialog = t0 => {
  const $ = _c(64);
  const {
    server,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.tools.mcp"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    toast
  } = useToast();
  const showErrorToast = useRequestErrorToast();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      defaultValues: {
        headerValue: ""
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const form = useForm(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = patchOrgAgentsMcpServersByServerIdMutation();
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onClose || $[4] !== server.name || $[5] !== t || $[6] !== toast) {
    t4 = () => {
      toast({
        variant: "default",
        title: t(_temp, {
          name: server.name
        }),
        description: ""
      });
      onClose();
    };
    $[3] = onClose;
    $[4] = server.name;
    $[5] = t;
    $[6] = toast;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== showErrorToast || $[9] !== t4) {
    t5 = {
      ...t3,
      onSuccess: t4,
      onError: showErrorToast
    };
    $[8] = showErrorToast;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const mutation = useMutation(t5);
  let t6;
  if ($[11] !== mutation.isPending || $[12] !== onClose) {
    t6 = () => {
      if (!mutation.isPending) {
        onClose();
      }
    };
    $[11] = mutation.isPending;
    $[12] = onClose;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleClose = t6;
  let t7;
  if ($[14] !== mutation || $[15] !== server.id) {
    t7 = data => {
      mutation.mutate({
        path: {
          serverId: server.id
        },
        body: {
          headerValue: data.headerValue
        }
      });
    };
    $[14] = mutation;
    $[15] = server.id;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const onSubmit = t7;
  let t8;
  if ($[17] !== t) {
    t8 = t(_temp2);
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t(_temp3);
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== mutation.isPending || $[22] !== t9) {
    t10 = {
      form: "replace-header-value-form",
      label: t9,
      loading: mutation.isPending,
      type: "submit"
    };
    $[21] = mutation.isPending;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t(_temp4);
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== handleClose || $[27] !== mutation.isPending || $[28] !== t11) {
    t12 = {
      label: t11,
      disabled: mutation.isPending,
      onClick: handleClose
    };
    $[26] = handleClose;
    $[27] = mutation.isPending;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== form || $[31] !== onSubmit) {
    t13 = form.handleSubmit(onSubmit);
    $[30] = form;
    $[31] = onSubmit;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== server.headerName || $[34] !== server.name || $[35] !== t) {
    t14 = t(_temp5, {
      header: server.headerName,
      name: server.name
    });
    $[33] = server.headerName;
    $[34] = server.name;
    $[35] = t;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t14) {
    t15 = <p className="text-body-2 text-secondary">{t14}</p>;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t) {
    t16 = t(_temp6);
    $[39] = t;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t) {
    t17 = t(_temp7);
    $[41] = t;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t) {
    t18 = t(_temp8);
    $[43] = t;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t18) {
    t19 = {
      required: t18
    };
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t16 || $[48] !== t17 || $[49] !== t19) {
    t20 = <Form.Input size="compact" name="headerValue" type="password" label={t16} hint={t17} placeholder={"Bearer \u2026"} autoComplete="new-password" data-dd-privacy="mask" rules={t19} />;
    $[47] = t16;
    $[48] = t17;
    $[49] = t19;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== t13 || $[52] !== t15 || $[53] !== t20) {
    t21 = <form id="replace-header-value-form" onSubmit={t13} className="flex flex-col gap-4">{t15}{t20}</form>;
    $[51] = t13;
    $[52] = t15;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== form || $[56] !== t21) {
    t22 = <FormProvider {...form}>{t21}</FormProvider>;
    $[55] = form;
    $[56] = t21;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== handleClose || $[59] !== t10 || $[60] !== t12 || $[61] !== t22 || $[62] !== t8) {
    t23 = <Dialog open={true} onClose={handleClose} title={t8} size="compact" primaryButton={t10} secondaryButton={t12}>{t22}</Dialog>;
    $[58] = handleClose;
    $[59] = t10;
    $[60] = t12;
    $[61] = t22;
    $[62] = t8;
    $[63] = t23;
  } else {
    t23 = $[63];
  }
  return t23;
};
export default ReplaceHeaderValueDialog;
function _temp($) {
  return $.replaceHeader.done;
}
function _temp2($_0) {
  return $_0.replaceHeader.title;
}
function _temp3($_1) {
  return $_1.replaceHeader.submit;
}
function _temp4($_2) {
  return $_2.replaceHeader.cancel;
}
function _temp5($_3) {
  return $_3.replaceHeader.description;
}
function _temp6($_4) {
  return $_4.dialog.headerValue.label;
}
function _temp7($_5) {
  return $_5.dialog.headerValue.hint;
}
function _temp8($_6) {
  return $_6.dialog.headerValue.required;
}